import { fetchAPI } from 'libs/apis'
import { QRCodeForFindOne } from 'types'

export const findOneById = async (id: string): Promise<QRCodeForFindOne> => {
  const response = await fetchAPI<QRCodeForFindOne>({
    apiUrl: window._env_.REACT_APP_API_URL,
    method: 'GET',
    path: `/v1/qr-code/${id}`,
  })

  return response.body
}
